import { useTranslation } from 'react-i18next'

import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'

import { TdsDivider } from '@scania/tegel-react'
import { Title } from './audit-point-info-card.styles'
import type { AuditPointInfoCardProps } from './audit-point-info-card.types'

export function AuditPointInfoCard({
  purposeDescription,
  description
}: AuditPointInfoCardProps) {
  const { t } = useTranslation()
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')

  return (
    <>
      {!isLg && (
        <>
          <Title>{t('description')}</Title>
          <p>{description}</p>

          <TdsDivider variant='discrete' />
        </>
      )}

      <Title>{t('purpose')}</Title>
      {purposeDescription}
    </>
  )
}
